import { DeliveryProcessDefinitionDetailDto } from '@/api/backoffice/clients';
import { ENUM_StatusTypes } from './configuration-enumerations.common';

export const getDeliveryProcessDefinitionLabel = (definition: DeliveryProcessDefinitionDetailDto) => {
    let label = definition.label;
    if (definition.statusId != ENUM_StatusTypes.Actief.id) {
        const statusLabel = Object.values(ENUM_StatusTypes).find((x) => x.id == definition.statusId)?.name;
        label = `${definition.label} - ${statusLabel}`;
    }
    return label;
};

export enum DeliveryProcessDefinitionActionButtonType {
    ChangeStatus = 'ChangeStatus',
    Duplicate = 'Duplicate',
    CascadeDelete = 'CascadeDelete',
    Export = 'Export',
    DryRun = 'DryRun',
    Dependencies = 'Dependencies',
    GenerateReport = 'GenerateReport',
    GeckoExport = 'GeckoExport',
    GeckoConfiguration = 'GeckoConfiguration'
}
